export default "<p>test works!</p>\n<button mat-raised-button style=\"flex: 1\" color=\"primary\" (click)=\"showdialog()\"> click to show dialog</button>\n\n";